import axios from "axios";

// Création d'une instance axios avec la configuration de base
const api = axios.create({
  baseURL: `${import.meta.env.VITE_BACKEND_API_URL}/${
    import.meta.env.VITE_VERSION_API
  }`,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const createMultipartRequest = async (data) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (value != null) {
      if (value instanceof File) {
        console.log(`Ajout du fichier ${key}:`, {
          name: value.name,
          type: value.type,
          size: `${(value.size / 1024).toFixed(2)} KB`,
        });

        formData.append(key, value, value.name);
      } else if (typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, String(value));
      }
    }
  }

  for (let pair of formData.entries()) {
    console.log(
      "FormData entry:",
      pair[0],
      pair[1] instanceof File
        ? `File: ${pair[1].name} (${(pair[1].size / 1024).toFixed(2)} KB)`
        : pair[1]
    );
  }

  return {
    formData,
    config: {
      headers: {
        Accept: "application/json",
      },
      maxBodyLength: Infinity,
      maxContentLength: Infinity,
    },
  };
};

// Intercepteur pour ajouter le token d'authentification à chaque requête
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Gestion des erreurs 401 (non autorisé) - redirection vers la page de connexion
    if (error.response && error.response.status === 401) {
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
